import React from 'react';
import { Circle, G } from 'react-native-svg';

import { IconDef, IconSpecificStyles } from './types';

export const Dot: IconDef = {
  svg: (
    <G>
      <Circle cx="12" cy="12" r="10" />
    </G>
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      fill: color,
      strokeWidth: 0,
    };
  },
};
